<mat-sidenav-container class="system-layout bg-primary2">
  <mat-sidenav
    #drawer
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
    class="bg-primary2"
    fixedInViewport
  >
    <!-- SIDEBAR START HERE -->
    <app-sidebar [sidebarMenu]="sideMenu"></app-sidebar>
    <!-- SIDEBAR END HERE -->
  </mat-sidenav>

  <mat-sidenav-content>
    <!-- CONTENT START HERE -->
    <div
      class="bg-gray-50 shadow-md mr-4 my-2 p-2 rounded-md border border-gray-600 flex justify-content-between flex-wrap"
    >
      <div class="flex justify-start items-center grow flex-wrap">
        <div [class.remove-offset]="isHandset$ | async" class="left-panel">
          <button
            (click)="drawer.toggle()"
            *ngIf="isHandset$ | async"
            aria-label="Toggle sidenav"
            class="btn-toggle text-primary"
            mat-icon-button
            type="button"
          >
            <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
          @if (userProfile?.profileType !== 'Executive') {
            <button
              aria-label="Toggle sidenav"
              class="primary-btn -mt-2 !rounded-full flex items-center justify-center"
              mat-raised-button
              routerLink="/tgsd-landing" type="button">
              <mat-icon svgIcon="home"></mat-icon>
              <span class="pt-1 pl-2">Home</span>
            </button>
          }
        </div>

        <div class="font-bold mx-2 text-xl">{{ title }}</div>
      </div>

      <!-- right-panel -->
      <div class="flex gap-2 pr-2">
        <button (click)="notifications()" class="notifications" mat-icon-button style="margin-right: 10px">
          <app-font-awesome-icon matBadge="{{ totalUnreadNotification }}" matBadgeColor="warn" iconName="notification"></app-font-awesome-icon>
        </button>


        <div
          #t="matMenuTrigger"
          [matMenuTriggerFor]="userMenu"
          class="flex gap-1 items-center cursor-pointer rounded-full bg-primary-50 p-0.5">
          <span class="d-flex align-items-center user-icon">
            <mat-icon *ngIf="!photo; else pic" color="white"
                      svgIcon="person"></mat-icon>
            <ng-template #pic>
              <img *ngIf="!!photo" alt="P"
                   class="rounded cursor-pointer text-center"
                   [src]="photo"/>
            </ng-template>
          </span>
          <div class="flex flex-col">
            <span class="text-sm">{{ userProfile?.userFirstName }} {{ userProfile?.userLastName }}</span>
            <span class="text-xs" *ngIf="userProfile?.userEmail">{{ userProfile?.userEmail }}</span>
          </div>

          <div
            class="flex items-center justify-center">
            <mat-icon [class.open]="t.menuOpen" style="color: white !important" class="trigger-arrow !text-white" svgIcon="chevron-down-black">
            </mat-icon>
          </div>
        </div>

      </div>
      <!-- end of right-panel -->
    </div>
    <app-content [hasMenu]="hasMenu"></app-content>
    <!-- CONTENT END HERE -->
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- HEADER START HERE -->

<!-- HEADER END HERE -->
<mat-menu #userMenu="matMenu">
  <button mat-menu-item routerLink="/user-profile">
    <mat-icon svgIcon="person"></mat-icon>
    Profile
  </button>

  <button mat-menu-item routerLink="/change-password">
    <mat-icon svgIcon="password_key"></mat-icon>
    Change Password
  </button>
  <mat-divider class="gradient"></mat-divider>

  <mat-divider class="gradient"></mat-divider>
  <button (click)="logout()" mat-menu-item>
    <mat-icon svgIcon="logout"></mat-icon>
    Logout
  </button>
</mat-menu>
